import { Accordion } from "./Accordion";
import classes from '../../Styles/BlackForest.module.css'
import Awaking from "../../../../images/Orcs/HistoryBlackForest/Awakening.webp"
import ExodusToTheBlackForest from "../../../../images/Orcs/HistoryBlackForest/ExodusToTheBlackForest.webp" 
import BoarValley from "../../../../images/Orcs/HistoryBlackForest/BoarValley.webp"
import Construction from "../../../../images/Orcs/HistoryBlackForest/Construction.webp"
import Council from "../../../../images/Orcs/HistoryBlackForest/Council.webp"
import Solution from "../../../../images/Orcs/HistoryBlackForest/Solution.webp"
import Booty from "../../../../images/Orcs/HistoryBlackForest/Booty.webp"
import DwarvenAttack from "../../../../images/Orcs/HistoryBlackForest/DwarvenAttack.webp"
import ScorchedSettlement from "../../../../images/Orcs/HistoryBlackForest/ScorchedSettlement.webp"
import FirstKing from "../../../../images/Orcs/HistoryBlackForest/FirstKing.webp"

export const AccordionState = () => {
    const accordionItems = [
      {
        title: 'История Чёрного Леса',
        content: (
<div className={classes.accordionItemContent}>
  <div className={classes.pictures}>
    <img title="Пробуждение" src={Awaking} className={classes.awaking} alt="Пробуждение" draggable="false"/>
    <img title="Исход в Чёрный Лес" src={ExodusToTheBlackForest} className={classes.exodus} alt="Исход в Чёрный Лес" draggable="false"/>
  </div>

    <div className={classes.contentScroll}>
      <h2>Пробуждение и новый дом</h2>
      <p><strong>
        Никто достоверно не знает, откуда появилась раса орков на континенте. Известно лишь, что она существовала ещё до Эпохи Зимы, но когда на Танах обрушился катаклизм, все зеленокожие словно растворились.
        Даже старейшие из них не знают ничего о судьбе своих предков. Поговаривают, будто бы орки - одна из первых цивилизаций, зародившихся в этом мире, так как следы их обитания находят практически везде, где только можно представить.
        Когда земля начала оттаивать ото льда, под пригорьем Медвежьих Вершин, в недрах земли, стали образовываться пустоты на месте вечной мерзлоты.
        Там, в пещерных залах, начали пробуждаться орочьи хранители духов, погружённые в вековой транс - Сон духов. Сбросив оковы сна, они стали будить остальных сородичей.
        После длительного пробуждения старший из хранителей повёл свой народ через извилистые тоннели пещер на юг. Там орки вышли на поверхность, увидев перед собой древние леса.
        Непроглядный мрак и туман окутывали огромные стволы чащобы. Лишь те немногие лучи солнца, что прорывались сквозь кроны деревьев, давали рассмотреть очертания местности. Это был тот самый Чёрный Лес, ставший для орков их новым домом.
      </strong></p> 
    </div>
</div>
        ),
      },
      {
        title: 'Первые Общины',
        content: (
          <div>
           <div className={classes.pictures}>
    <img title="Долина кабанов" src={BoarValley} className={classes.pictureLeft} alt="Долина кабанов" draggable="false"/>
    <img title="Строительство" src={Construction} className={classes.pictureRight} alt="Строительство" draggable="false"/>
  </div>
  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
      <h2>Первые Общины</h2>
      <p><strong> 
        По своей природе орки - охотники, а не собиратели. И это первое, чем они начали заниматься. Благо в лесах обитало множество разнообразной дичи, а самой массовой добычей стали кабаны. 
        Из-за преобладания дубов их количество исчислялось десятками тысяч. Охотники образовывали группы, а группы перерастали в своры, что привело к созданию одной организованной общины.
        Но среди орков нашлись и те, кто предпочитал всякого рода ремёсла, не связанные с охотой: работу с деревом, выделку шкур, выплавку металлов и многое другое.
        Для того чтобы строительство и обустройство быта шли эффективнее, бригадиры приступили к набору в свои группы мастеров разной направленности. 
        Позже, когда масштабы поселений выросли и потребовалось постоянное обслуживание, понадобилась община, объединяющая их всех в единый организм и направляющая рабочих туда, где это было нужно.
      </strong></p>
    </div>
          </div>
        ),
      },
      {
        title: 'Объединение',
        content: (
          <div>
      <div className={classes.pictures}>
   <img title="Решение" src={Solution} className={classes.pictureLeft} alt="Решение" draggable="false"/>
   <img title="Добыча" src={Booty} className={classes.pictureRight} alt="Добыча" draggable="false"/>
  </div>

  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Объединение</h2>
        <p><strong>
          Помимо охоты и ремёсел, у орков процветала тёмная сторона их натуры. Воровство у сородичей было повсеместным явлением, а ещё нападения на слабо охраняемые караваны и мародёрство также имели место.
          Так по всему лесу стали появляться малочисленные шайки, которые вели между собой открытую вражду. От этого страдало всё население Чернолесья. 
          Молодой вор Хармук устал смотреть, как его собратья режут друг другу глотки из-за мелочной поживы. Он организовал банду из первоклассных воров, пообещав им полное покровительство всей группировки. 
          Те же, в свою очередь, обязались оставлять процент от краж в казне сообщества. Но это был лишь первый шаг в наведении порядка.
          Новоиспечённый глава воров вызвал лидеров двух крупнейших шаек - грабителей и мародёров - на сходку, где предложил им пойти по тому же пути и позже объединиться в одну централизованную общину с запретом преступлений против соплеменников.
          Какое-то время беспорядки продолжались по инерции, но после избрания новым вождём жестокого и бескомпромиссного Родзарика такие одиночки, не имея за спиной крепкой опоры, в наказание теряли не только награбленное, но и жизни.
          Хармуку же доверили управление капиталом, который в итоге стал казной всего Чёрного Леса.
        </strong></p>
  </div>
  </div>
        ),
      },
      {
        title: 'Агрессия гномов',
        content: (
          <div>
      <div className={classes.pictures}>
   <img title="Нападение гномов" className={classes.pictureLeft} src={DwarvenAttack} alt="Нападение гномов" draggable="false"/>
   <img title="Выжженное поселение" className={classes.pictureRight} src={ScorchedSettlement} alt="Выжженное поселение" draggable="false"/>
  </div>

  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Агрессия гномов</h2>
        <p><strong>
          Дела в Чёрном Лесу стали налаживаться. Охотники снабжали дичью, рабочие отстраивали поселения, банды приносили прибыль, а хранители духов заботились о нематериальном мире. 
          Пока однажды с севера не пришли плохие новости. С Медвежьих Вершин спустились гномы и уничтожили все тамошние поселения. 
          Это были не слабые отряды патрулей, с которыми орки сталкивались не раз, наказывая забредших в лес вновь и вновь. На этот раз Чернолесье атаковали организованные войска огромной численности.
          Противостоять такой мощи орки не могли, и поселения сгорали одно за другим. Ближайший к горам лес выгорел полностью, лишь болота не дали продвинуться пламени вглубь. Группы, отправившиеся на помощь собратьям, практически не обнаружили выживших. 
          По большинству обгоревших тел зеленокожих можно было понять, что погибли они в муках или же были казнены. Ярость от увиденного захлестнула весь Чёрный Лес. Общины взбунтовались и требовали жёсткого ответа. Требовался лидер, который поведёт эту волну к возмездию.
        </strong></p>
  </div>
          </div>
        ),
      },
      {
        title: 'Первый король',
        content: (
          <div>
      <div className={classes.pictures}>
  <img title="Собрание" className={classes.pictureLeft} src={Council} alt="Собрание" draggable="false"/>
  <img title="Первый король" className={classes.pictureRight} src={FirstKing} alt="Первый король" draggable="false"/>
  </div>
  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Первый король</h2>
        <p><strong>
          У орков никогда не было правителя. Все вопросы по управлению жизнедеятельностью страны решались главами общин, что иногда приводило к неразберихе. 
          Агрессия гномов обнажила уязвимое место в общинном порядке. После вероломного нападения первый хранитель духов Норгуз созвал совет у Чёрной скалы.
          К месту проведения собрания со всего леса потянулись толпы зеленокожих, жаждавших справедливого ответа за безжалостную резню побратимов. 
          Как будто всё Чернолесье задышало в одном ритме, и звуки природы стихли, прислушиваясь к этому дыханию.
          Каждый из предводителей желал стать единовластным королём. Спустя долгие споры они решили поделить корону правления по временам года. 
          Зимой королём становился первый хранитель духов, весной - главный бригадир рабочих, летом - старший охотник, а осенью - вождь банд.
          Первым королём выпала честь стать Родзарику, главе разбойников, мародёров и воров. Не колеблясь, он провозгласил во всеуслышание, чтобы орки готовились к войне.
        </strong></p>
  </div>
          </div>
        ),
      }
    ];
  
    return (
      <div>
        <Accordion items={accordionItems} />
      </div>
    );
  }